<template>
    <v-data-table
        v-model="selected"
        :headers="headers"
        :items="items"
        :search="search" 
        item-key="id"
        class="elevation-1"
    >
        <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title style="color:#1C2546;margin-top:40px">Gastos</v-toolbar-title>
                <v-divider class="mx-4" inset vertical style="margin-top:30px"></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <div class="text-right" style="margin-top:35px">
                <v-btn class="ma-2" tile color="primary" dark @click="add_new = true">
                    <v-icon left>mdi-plus</v-icon> Añadir nuevo
                </v-btn>
            </div>
            <v-dialog v-model="add_new"  max-width="850" >  
                <v-card>
                    <v-card-title>
                    <span class="headline">Añadir nuevo gasto</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="new_ob.gasto" label="Gasto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close_new">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save_new">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="edit"  max-width="850" >  
                <v-card>
                    <v-card-title>
                    <span class="headline">Editar gasto</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12" md="12">
                                    <v-text-field v-model="editing.gasto" label="Gasto"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close_edit">Cancelar</v-btn>
                            <v-btn color="blue darken-1" text @click="save_edit">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="confirmacion_delete"  max-width="850">
                <v-card>
                    <v-card-title><span class="headline">Eliminar Gasto</span></v-card-title>
                    <v-card-text>
                        ¿Estas seguro de eliminar este gasto?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="confirmacion_delete = false">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="delete_gasto">Confirmar</v-btn>
                    </v-card-actions>
                </v-card> 
            </v-dialog>
            <v-row justify="center">
                <v-col cols="10" sm="10" md="10">
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Buscar">
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class="justify-content-center col-lg-12">      
                <v-alert type="success" :value='alertSucess' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
                <v-alert type="error" :value='alertError' close-text="Cerrar">
                    {{ message }}
                </v-alert> 
            </v-row>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
            >
                mdi-pencil
            </v-icon>
            <v-icon
                small
                class="mr-2"
                @click="deleteItem(item)"
            >
                mdi-delete
            </v-icon>
        </template>
    </v-data-table>
</template>

<script>
import axios from "axios";
import router from '../../router/index.js';

export default {
    data(){
        return {
            headers: [
                { text: "ID", value: "id_gasto", sortable: true },
                { text: "Gasto", value: "gasto", sortable: false },
                { text: "Acciones", value: "actions", sortable: false },
            ],
            items: [],
            selected: [],
            search: '',
            add_new: false,
            new_ob: {
                gasto: '',
            },
            isVisible: false,
            message: '',
            alertSucess: false,
            alertError: false,
            editing: {},
            edit: false,
            selected_item: null,
            confirmacion_delete:false
        }
    },
    mounted() {
        // Config for axios
        axios.defaults.headers.common['access-token'] = this.$store.state.token;
        axios.interceptors.response.use(function (response){
            if (response.data.message == 'Token inválida') {
                router.push({name: 'login', params: {errorToken: 'true'}});
            }else{
                return response;
            }
        },function(error){
            if(error){
                //console.log(error);
            }  
        });
        // End config for axios
        this.getList();
    },
    methods: {
        getList() {
            axios.get("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/gastos").then(res => {
                //console.log(res.data);
                this.items = res.data;
            });
        },
        close_new(){
            this.new_ob.gasto = '';
            this.add_new = false;
        },
        save_new(){
            axios.post("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/gastos/",this.new_ob).then(res => {
                //console.log(res);
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;

                this.new_ob.gasto = '';
                this.add_new = false;
                this.getList();
            });
        },
        deleteItem(item){
            this.selected_item = item;
            this.confirmacion_delete = true;
        },
        delete_gasto(){
            axios.delete("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/gastos/"+this.selected_item.id_gasto).then(res => {
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;

                this.getList();
                this.confirmacion_delete = false;
            });
        },
        editItem(item){
            this.editing = item;
            this.edit = true;
        },
        close_edit(){
            this.editing = {};
            this.edit = false;
        },
        save_edit(){
            axios.put("https://"+process.env.VUE_APP_URL+":3000/gastos/api/v1/gastos/",this.editing).then(res => {
                //console.log(res);
                this.message = res.data.message;
                this.alertError = false;
                this.alertSucess = true;

                this.editing = {};
                this.edit = false;
                this.getList();
            });
        },
    }  
}
</script>

<style>

</style>